import React, { useState, useEffect, useMemo } from "react";
import { Page, SubmitButton, FormGroup, DatePicker, PendingButton } from "components/common";
import { Button } from 'reactstrap';
import Dropzone from "react-dropzone";
import { Control, actions, Fieldset, track, Errors } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm, usePopover } from "hooks";
import Select from "react-select";
import { Trans, useTranslation } from "react-i18next";
import { PopoverBody, Table, Nav, TabContent, TabPane, Row, Col } from "reactstrap";
import produce from "immer";
import { isCurrency } from "services/util";
import shortid from "shortid";
import countryList from 'react-select-country-list';
import BackButton from "components/refactoring/BackButton";
import { useUserContext } from "hooks";
import { createDelayedFunction } from 'Helpers'
import { useBaseModal } from "services";
import { Link } from "react-router-dom";
import CopyField from "components/common/copy-field";

const statusOption = [
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Inactive",
    value: "Inactive",
  }
];


const AMOUNT_TYPE = {
  PERCENTAGE: "PERC",
  FIXED: "FXD"
};
export const EmployeeEdit = ({
  xero,
  payroll,
  t,
  url = "employees",
  model = "local",
  history,
  match,

}) => {
  const { id } = match.params;
  const { dispatch, setValue, value, Form, save, loaded, load, getTitle } =
    useForm({
      model,
    });
  const { setIsOpen, toggle, Popover } = usePopover();
  const [trackingOptions, setTrackingOptions] = React.useState([]);
  const [activeTab, setActiveTab] = useState('1');
  const [allowanceOptions, setAllowanceOptions] = React.useState([]);
  const [deductionOptions, setDeductionOptions] = React.useState([]);
  const [deductionOptionsInitial, setDeductionOptionsInitial] = React.useState([]);
  const [allowanceRuleObj, setAllowanceRuleObj] = React.useState({});
  const [deductionRuleObj, setDeductionRuleObj] = React.useState({});
  const [endOfServiceOptions, setEndOfServiceOptions] = React.useState([]);
  const [shiftOptions, setShiftOptions] = React.useState([]);
  const [nextSerialNumber, setNextSerialNumber] = useState();
  const [salaries, setSalaries] = React.useState([]);
  const { i18n } = useTranslation();
  const { country } = useUserContext();

  const [invited, setInvited] = useState(false);

  const countryOptions = useMemo(() => countryList().getData(), [])

  const [SetHistoryOpen, HistoryToggle, HistoryModal] = useBaseModal();


  useEffect(() => void onMount(), []);
  const onMount = async () => {
    const allowanceRules = await payroll.get("allowance_rules").get("data");
    setAllowanceOptions(allowanceRules);

    const _eos = await payroll.get("end_of_service/options").get("data");
    setEndOfServiceOptions(_eos);

    const deductionRules = await payroll.get("deductions").get("data");
    setDeductionOptions(deductionRules);
    setDeductionOptionsInitial(deductionRules);

    let data = await xero.get("trackingcategories").get("data");
    setTrackingOptions(data);

    const shifts = await payroll.get("shifts").get("data");
    setShiftOptions(shifts);
    
    const payroll_settings = await payroll.get("settings/1").get("data");
    setNextSerialNumber(payroll_settings?.next_employee_number);

    let salaries = []
    if (id !== 'new') {
      salaries = await payroll.get(`contracts/employee_contracts/${id}`).get("data");
    }
    setSalaries(salaries);
  };

  useEffect(() => {
    setDeductionOptions(deductionOptionsInitial.filter((option) => option.apply_to_employees.some((type) => type.name === value.type && type.value)));
  }, [value.type])

  useEffect(() => {
    async function fetchData() {
      const initial = {
        status: "Active",
        holiday_offset: "0.00",
        invited: false,
        working_days: [true, true, true, true, true, false, false],
        allowances: [],
        deductions: [],
        invited_einvoice: false,
        id_end_date: null,
      }

      const item = await load(payroll, url, id, initial);
      item.already_invited = item.invited;
      item.already_invited_einvoice = item.invited_einvoice;
      //item.salary = item.monthly_salary*12;
      setValue({ ...item, type: item.id_end_date !== null ? "Foreigner" : "Local" });
      setInvited(item.invited);
    }
    fetchData();
  }, [id]);

  const handleInvited = (e) => {
    setInvited(e.target.checked)
  }
  const days = useMemo(
    () => ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((i) => t(i)),
    [t]
  );
  const onMonthSalaryChange = (event) => {
    let salary = event.target.value;
    setValue({ ...value, salary: (salary*12).toFixed(2), /* overtime_per_hour: msalary/8*/ })
  }
  const onAllowanceRuleChange = (e) => {
    setAllowanceRuleObj(allowanceOptions.filter(function (obj) { return obj.id === e; })[0]);
  };
  function handleRemoveAllowance(e, idx) {
    if (value.allowances[idx].allowance_rule) dispatch(actions.remove("local.allowances", idx));
    else {
      const copiedAllowances = [...value.allowances];
      delete copiedAllowances.splice(idx, 1);
      setValue({ ...value, allowances: [...copiedAllowances] });
    }
  }

  const onDeductionRuleChange = (e) => {
    setDeductionRuleObj(deductionOptions.filter(function (obj) { return obj.id === e; })[0]);
  };
  function handleRemoveDeduction(e, idx) {
    if (value.deductions[idx].deduction_rule) dispatch(actions.remove("local.deductions", idx));
    else {
      const copiedDeductions = [...value.deductions];
      delete copiedDeductions.splice(idx, 1);
      setValue({ ...value, deductions: [...copiedDeductions] });
    }
  }


  function calculateAmounts(obj, percentage, totals) {
    if (percentage) {
      return (parseFloat(totals.reduce((a, b) => parseFloat(a) + parseFloat(b))) * parseFloat(obj.amount) * 0.01).toFixed(2).toString()
    } else {
      totals.map(element => element + obj.amount)
      return (parseFloat(totals.length * obj.amount)).toFixed(2).toString()
    }
  }


  if (allowanceRuleObj.id) {
    const percentage = allowanceRuleObj.amount_type === AMOUNT_TYPE.PERCENTAGE
    const fixed = allowanceRuleObj.amount_type === AMOUNT_TYPE.FIXED
    if (percentage || fixed) {
      const allowance_rules = value.allowances.map((val) => {
        let copyVal = { ...val };
        if (allowanceRuleObj.id == val.allowance_rule) {
          copyVal.amount = calculateAmounts(allowanceRuleObj, percentage, [value.monthly_salary])
          copyVal.description = allowanceRuleObj.description;
        }
        return copyVal;
      });
      setValue({ ...value, allowances: allowance_rules });
      setAllowanceRuleObj({});
    }
  }

  if (deductionRuleObj.id) {
    const percentage = deductionRuleObj.amount_type === AMOUNT_TYPE.PERCENTAGE
    const fixed = deductionRuleObj.amount_type === AMOUNT_TYPE.FIXED
    if (percentage || fixed) {
      const deduction_rules = value.deductions.map((val) => {
        let copyVal = { ...val };
        if (deductionRuleObj.id == val.deduction_rule) {
          const chosen_allowances = value.allowances.filter((allowance) => deductionRuleObj.apply_to_allowances.some((_allowance) => (_allowance.id === allowance.allowance_rule)))
          let totals = chosen_allowances.map((allowance) => parseFloat(allowance.amount))
          totals.push(parseFloat(value.monthly_salary))
          copyVal.amount = calculateAmounts(deductionRuleObj, percentage, totals)
          copyVal.description = deductionRuleObj.description;
        }
        return copyVal;
      });
      setValue({ ...value, deductions: deduction_rules });
      setDeductionRuleObj({});
    }
  }
  async function onDropAccepted(x) {
    const reader = new FileReader();
    reader.onload = (e) => {
      dispatch(actions.change("local.employee_picture", e.target.result));
    };
    reader.readAsDataURL(x[0]);
  }

  async function onLogoError(item) {
    dispatch(actions.setErrors("item.employee_picture", { invalid: true }));
  }

  async function onLogoLoad(item) {
    dispatch(actions.setErrors("item.employee_picture", { invalid: false }));
  }

  const requiredFields = [
    'serial_number',
    'first_name',
    'last_name',
    'phone_number',

    'date_of_birth',
    'nationality',
    'id_number',

    'position',
    'salary',
    'monthly_salary',
    'start_date',

    'working_days',
  ];

  function validateFields(item) {

    const fieldNames = {
      first_name: 'First Name',
      serial_number: 'Serial Number',
      middle_name: 'Middle Name',
      last_name: 'Last Name',
      email: 'Email',
      date_of_birth: 'Date of Birth',
      medical_number: 'Medical Number',
      position: 'Position',
      company_name: 'Insurance Company name',
      start_date: 'Joining Date',
      start_date_insurance: 'Insurance Start Date',
      end_date_insurance: 'Insurance End Date',
      category: 'Insurance Category',
      amount: 'Insurance Amount',
      num_holiday_days: 'Holidays per year',
      phone_number: 'Phone Number',
      employee_picture: 'Employee Picture',
      qualification: 'Qualification',
      //status: 'Status',
      end_date: 'End Date',
      address: 'Address',
      type_job: 'Job Type',
      id_number: 'ID Number',
      holiday_offset: 'Opening Holiday Balance',
      invited: 'Invite to',
      monthly_salary: 'Monthly Salary',
      nationality: 'Nationality',
      working_days: 'Working Days',
      salary: 'Salary',
      overtime_per_hour: 'Overtime Per Hour',
      bank_name: 'Bank Name',
      account_number: 'Account Number',
      iban: 'IBAN',
      route: 'Route',
      swift: 'SWIFT',
      country: 'Country',
    };

    for (const field of requiredFields) {
      if (!item[field]) {
        return t("Please fill in the required field ") + t(fieldNames[field]);
      }
    }
    return null;
  }

  function isForeigner(val) {
    if (!(typeof val === 'string' || val instanceof String)) {
      return val
    }
    if (val === country) {
      setValue({ ...value, type: 'Local' })
    } else {
      setValue({ ...value, type: 'Foreigner' })
    }
    return val
  }

  const isForeignerDelayed = createDelayedFunction(isForeigner, 500);


  async function onSubmit(item) {

    if (!item.email && invited) {
      NotificationManager.error(t('Please enter a valid employee email for invitation.'))
      return
    }

    try {
      dispatch(actions.setPending("local"));
      var id_end_date = item.type === 'Foreigner' ? item.id_end_date : ''
      const tracking_categories = trackingOptions?.map((tracking) => tracking.Name) || [];
      item = {
        ...item,
        employee_picture: item.employee_picture || null,
        lang: i18n.language,
        id_end_date: id_end_date,
        invited: invited,
        tracking: tracking_categories?.reduce((obj, key) => {
          if (item.tracking && (key in item.tracking || [])) {
            obj[key] = item.tracking[key];
          }
          return obj
        }, {}) || {}
      };
      const validationError = validateFields(item);

      if (validationError) {
        NotificationManager.error(validationError, t('Complete The Form'));
        if (activeTab === "1") {
          NotificationManager.error(t('Please fill in All the Details'), t('Turn the page'));
        }
        return;
      }

      Object.keys(item).forEach(key => {
        if (!requiredFields.includes(key) && key !== 'type' && (item[key] === "" || item[key] === null)) {
          delete item[key];
        }
      });

      await save(payroll, url, item);

      NotificationManager.success(t("Saved successfully"));
      history.replaceUp()
    } catch (ex) {
      const detail = ex.response?.data?.detail;

      if (detail) {
        NotificationManager.error(t(detail));
        ex.handled = true;
      } else {
        throw ex;
      }
    } finally {
      dispatch(actions.setPending(model, false));
      //alert("Submit local")
      dispatch(actions.setSubmitted("local"));
    }
  }
  async function onResendInvite() {
    if (!value.email) {
      NotificationManager.error(t('Please enter a valid employee email for invitation.'))
      return
    }
    dispatch(actions.setPending(model, true));
    try {
      await payroll.post(`employees/${value.id}/resend_invite`).get("data");
      NotificationManager.success(t("Invite email successfully sent"));
    } finally {
      dispatch(actions.setPending(model, false));
    }
  }
  async function onRevokeUser() {
    setIsOpen(false);
    dispatch(actions.setPending(model, true));
    try {
      const data = await payroll
        .post(`employees/${value.id}/revoke_user`)
        .get("data");
      NotificationManager.success(t("User access revoked"));
      dispatch(actions.merge("local", data));
    } finally {
      dispatch(actions.setPending(model, false));
    }
  }

  const styleCheck = {
    style: { fontSize: "0.9em" },
    className: "ml-2"
  }

  const rowCheck = {
    className: "row pb-2 pt-2"
  }

  const fieldSet = {
    className: "border p-3 mt-3"
  }

  const legendSet = {
    className: "w-auto mb-0"
  }

  const nxtButton = {
    className: "btn-nxt bt btn btn-success mr-0 ml-3"
  }

  const justifyEnd = {
    className: "mt-3 d-flex justify-content-end"
  }

  const navTab = {
    style: {
      style: { cursor: 'pointer', fontSize: '1.05em', padding: 10 },
    },
    numbers: {
      style: { fontSize: '0.8em' },
    }
  };

  const handleAttachmentClick = (details) => {
    const { id, full_name } = details
    const attachURL = `/payroll/attachments?id=${id}&name=${full_name}`;
    history.push(attachURL);
  };

  const insuranceOptions = [
    { label: "Class A", value: "Class A" },
    { label: "Class B", value: "Class B" },
    { label: "Class C", value: "Class C" },
    { label: "Class D", value: "Class D" },
    { label: "Not Applicable", value: "Not Applicable" },
  ]

  const [addShift, setAddShift] = useState(false)

  if (!loaded || !nextSerialNumber) return null;
  return (
    <Page title={getTitle(id, "Employee")} className="inv-tabs nw-list">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <BackButton />
        {id !== "new" &&
          <div className="actions">
            {!!value.invitation_link && <div className="d-inline-block"><CopyField value={value.invitation_link} title="Copy Invite Link"/></div>}
            <Button onClick={() => SetHistoryOpen(true)} color="primary"><i className="fas fa-dollar-sign mr-2" /><Trans>Salary History</Trans></Button>
            <Button onClick={() => handleAttachmentClick(value)} color="primary"><i className="fas fa-paperclip mr-2" /><Trans>Attachments</Trans></Button>
          </div>
        }
      </div>
      <Form
        onSubmit={onSubmit}
        validators={{
        }}
      >

        <div>
          <Nav tabs className="nw-tabs2 inv-tabs mb-3">
            <div {...navTab.style} onClick={() => setActiveTab('1')} className={activeTab == '1' ? `active-tabNum` : ``}>
              <Trans>General Information</Trans>
            </div>
            <div {...navTab.style} onClick={() => setActiveTab('2')} className={activeTab == '2' ? `active-tabNum` : ``}>
              <Trans>Work Information & Job Description</Trans>
            </div>
            <div {...navTab.style} onClick={() => setActiveTab('3')} className={activeTab == '3' ? `active-tabNum` : ``}>
              <Trans>Medical & Financial Data</Trans>
            </div>
            <div {...navTab.style} onClick={() => setActiveTab('4')} className={activeTab == '4' ? `active-tabNum` : ``}>
              <Trans>Allowances & Deductions</Trans>
            </div>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <React.Fragment>
                <div className="row mb-3">
                  <FormGroup label={t("Employee Picture")} model=".employee_picture" className="ml-3">

                    <Dropzone style={{ cursor: 'pointer', backgroundColor: '#72B566', borderRadius: '6px', color: '#fff' }}
                      multiple={false}
                      className="border border-success rounded"
                      onDropAccepted={onDropAccepted}
                    >
                      <div className="m-2 text-center" >
                        {value.employee_picture ? (
                          <div>
                            <img
                              alt="employee picture"
                              onLoad={onLogoLoad}
                              onError={onLogoError}
                              className="img-thumbnail mb-3"
                              src={value.employee_picture}
                              style={{ maxHeight: "120px" }}
                            />
                          </div>
                        ) : null}
                        {value.employee_picture ? "" : <span >
                          <Trans>
                            <div style={{ fontSize: '13px' }}><i className="fa fa-camera" aria-hidden="true"></i> <Trans>Upload Picture</Trans></div>
                          </Trans>
                        </span>}
                      </div>
                    </Dropzone>

                    <Errors
                      model=".employee_picture"
                      component={(props) => (
                        <p className="form-text small text-danger" {...props} />
                      )}
                      messages={{
                        invalid: t("This is not a valid image file"),
                      }}
                    />
                  </FormGroup>
                </div>
                <fieldset {...fieldSet}>
                  <legend {...legendSet}><Trans>General Information</Trans></legend>
                  <div {...rowCheck}>
                    <FormGroup label={t("Employee serial number")} model=".serial_number" className="col-sm">
                      <Control.text model=".serial_number" updateOn="blur" autoComplete="off" autoCorrect="off" spellCheck="off" defaultValue={value.serial_number || nextSerialNumber} />
                    </FormGroup>
                    <FormGroup label={t("First Name") + " *"} model=".first_name" className="col-sm">
                      <Control.text model=".first_name" updateOn="blur" autoComplete="off" autoCorrect="off" spellCheck="off" placeholder={t("Surname")} />
                    </FormGroup>

                    <FormGroup label={t("Middle Name")} model=".middle_name" className="col-sm">
                      <Control.text model=".middle_name" updateOn="blur" autoComplete="off" autoCorrect="off" spellCheck="off" placeholder={t("Maiden Name")} />
                    </FormGroup>
                    <FormGroup label={t("Last Name") + " *"} model=".last_name" className="col-sm">
                      <Control.text model=".last_name" updateOn="blur" autoComplete="off" autoCorrect="off" spellCheck="off" placeholder={t("Family Name")} />
                    </FormGroup>
                  </div>
                  <div {...rowCheck}>

                    <FormGroup label={t("Email Address") + " *"} model=".email" className="col-sm mb-2">
                      <Control.text model=".email" updateOn="blur" placeholder="example@domain.com" autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                    <FormGroup label={t("Phone Number") + " *"} model=".phone_number" className="col-sm">
                      <Control.text model=".phone_number" updateOn="blur" autoComplete="off" autoCorrect="off" spellCheck="off" placeholder={t("Include Country Code")} />
                    </FormGroup>
                    <FormGroup label={t("Date of Birth") + " *"} model=".date_of_birth" className="col-sm">
                      {/* <Input type="date" className="form-control" model=".date_of_birth"/> */}
                      <DatePicker className="form-control" model=".date_of_birth" />
                    </FormGroup>
                  </div>
                </fieldset>
                <fieldset {...fieldSet}>
                  <legend {...legendSet}><Trans>Personal Information</Trans></legend>
                  <div {...rowCheck}>
                    <FormGroup
                      label={t("Nationality") + " *"}
                      model=".nationality"
                      addControlClass={false}
                      className="col-sm" >
                      <Control.text style={{ backgroundColor: '#F4F7FE' }}
                        model=".nationality"
                        component={Select}
                        options={countryOptions}
                        simpleValue
                        clearable={false}
                        searchable={true}
                        placeholder={t('Origin..')}
                        getValue={isForeignerDelayed}
                      />

                    </FormGroup>
                    <FormGroup label={t("ID Number") + " *"} model=".id_number" className="col-sm">
                      <Control.text model=".id_number" updateOn="blur" placeholder="ID number - 10 digit" autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                    {value.type === 'Foreigner' &&
                      <FormGroup
                        label={t("ID End Date")}
                        model=".id_end_date"
                        className="col-sm">
                        <DatePicker className="form-control" model=".id_end_date" />
                      </FormGroup>
                    }
                  </div>
                  <div {...rowCheck}>
                    <FormGroup label={t("Address")} model=".address" className="col-sm">
                      <Control.text model=".address" updateOn="blur" autoComplete="off" autoCorrect="off" spellCheck="off" placeholder={t("Full Employee Address")} />
                    </FormGroup>
                    <FormGroup
                      label={t("Status") + " *"}
                      model=".status"
                      addControlClass={false}
                      className="col-sm" >
                      <Control.text style={{ backgroundColor: '#F4F7FE' }}
                        model=".status"
                        component={Select}
                        options={statusOption}
                        simpleValue
                        clearable={false}
                        searchable={false}
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck="off"
                        placeholder={t('Employee Status...')}
                      />
                    </FormGroup>
                  </div>
                </fieldset>
                <div {...justifyEnd}>
                  <SubmitButton {...nxtButton}>Save</SubmitButton>
                  <button type="button" onClick={() => setActiveTab('2')} {...nxtButton}><Trans>Next</Trans></button>
                </div>
              </React.Fragment>
            </TabPane>
            <TabPane tabId="2">
              <React.Fragment>
                <fieldset {...fieldSet}>
                  <legend {...legendSet}><Trans>Job Information</Trans></legend>
                  <div {...rowCheck}>
                    <FormGroup label={t("Position") + "*"} model=".position" className="col-md-6 col-sm-12" >
                      <Control.text model=".position" placeholder={t("Employee Position")} disabled={id === 'new' ? false : true} />
                    </FormGroup>
                    <FormGroup label={t("Qualification")} model=".qualification" className="col-sm">
                      <Control.text model=".qualification" updateOn="blur" autoComplete="off" autoCorrect="off" spellCheck="off" placeholder={t("Highest Qualification")} />
                    </FormGroup>
                  </div>
                  <div {...rowCheck}>
                    <FormGroup label={t("Opening Holiday Balance")} model=".holiday_offset" className="col-md-6 col-sm-12">
                      <Control.text model=".holiday_offset" placeholder={t("Number of Holidays at start")} updateOn="blur" autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                    <FormGroup label={t("Paid Annual leave")} model=".num_holiday_days" className="col-md-6 col-sm-12">
                      <Control.text model=".num_holiday_days" placeholder={t("Total Annual Leaves")} updateOn="blur" autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                  </div>
                </fieldset>
                <fieldset {...fieldSet}>
                  <legend {...legendSet}><Trans>Salary & Shift Information</Trans></legend>
                  <div {...rowCheck}>
                    <FormGroup label={t("Monthly Salary") + "*"} model=".monthly_salary" className="col-sm" >
                      <Control.text onChange={onMonthSalaryChange} placeholder={t("Per Month")} model=".monthly_salary"/>
                    </FormGroup>
                    <FormGroup label={t("Annual Salary")} model=".salary" className="col-sm">
                      <Control.text model=".salary" placeholder={t("Auto Calculation")} disabled />
                    </FormGroup>
                    <FormGroup label={t("Overtime Rate per Hour")} model=".overtime_per_hour" className="col-sm">
                      <Control.text model=".overtime_per_hour" autoComplete="off" autoCorrect="off" spellCheck="off" placeholder={t("OT Per Hour %")} type="number" step="0.01" />
                    </FormGroup>
                  </div>
                  <div {...rowCheck}>
                    <FormGroup label={t("Joining Date") + "*"} model=".start_date" className="col-md-6 col-sm-12" >
                      {/* <Input type="date" className="form-control" model=".start_date" /> */}
                      <DatePicker className="form-control" model=".start_date"/>
                    </FormGroup>
                    <FormGroup
                      label="Leaving Date"
                      model=".end_date"
                      className="col-sm-6">
                      {/* <Input type="date" className="form-control" model=".end_date" /> */}
                      <DatePicker className="form-control" model=".end_date" placeholder="If Applicable" disabled />
                    </FormGroup>
                  </div>
                  <div {...rowCheck}>
                    <FormGroup
                      label="Shift"
                      model=".shift"
                      addControlClass={false}
                      className="col-md-4 col-sm-12 pr-5">
                      {(value.shift || addShift) ? <Control.text style={{ backgroundColor: '#F4F7FE' }}
                        model=".shift"
                        className=""
                        component={Select}
                        options={shiftOptions.map((y) => ({ value: y.id, label: y.name }))}
                        simpleValue
                        clearable={false}
                        searchable={false}
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck="off"
                        placeholder={t('Shift...')}
                      /> : <Button size="sm" onClick={() => setAddShift(true)}><Trans>Add/Change Shift</Trans></Button>}
                    </FormGroup>
                    <FormGroup label={t("Working Days") + " *"} model=".working_days" className="col-md-4 col-sm-12">
                      <div className="form-control-plaintext">
                        <Control.custom
                          model=".working_days"
                          render={({ modelValue, onChange }) => {
                            return (
                              <div className="d-inline-flex">
                                {days.map((i, idx) => (
                                  <div className="text-center mr-2" key={idx}>
                                    <div className="mb-1 small">{i}</div>
                                    <div>
                                      <input
                                        type="checkbox"
                                        checked={modelValue[idx]}
                                        onChange={(e) => {
                                          onChange(
                                            produce(modelValue, (draft) => {
                                              draft[idx] = e.target.checked;
                                            })
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            );
                          }}
                        />
                      </div>

                    </FormGroup>

                    <FormGroup className="col-md-4 col-sm-12 pt-4">
                      <div className="cta-radio-gr d-flex flex-column justify-content-center">
                        <div className="d-flex align-items-center my-1">
                          <input type="checkbox" checked={true} disabled /><span {...styleCheck}><Trans>Invite to Payroll</Trans></span>
                        </div>
                        <div className="d-flex align-items-center my-1">
                          <input model=".invited" type="checkbox" checked={invited} disabled={value.already_invited || value.already_invited_einvoice} onChange={handleInvited} /><span {...styleCheck}><Trans>Send Invitation Email</Trans></span>
                        </div>
                      </div>
                    </FormGroup>
                  </div>
                  <FormGroup >
                    <div className="d-flex align-items-center">
                      {value.user ? (
                        <>
                          <span className="small text-muted">
                            <Trans>Linked to</Trans> {value.user__full_name} {"<"}
                            {value.user__email}
                            {">"}
                          </span>
                          <SubmitButton
                            size="sm"
                            id="revoke-button"
                            className="my-3"
                            outline
                            onClick={toggle}
                          >
                            Revoke Access
                          </SubmitButton>
                          <Popover target="revoke-button" placement="bottom">
                            <PopoverBody>
                              <p className="text-center">
                                <Trans>Are you sure you revoke this users access?</Trans>
                              </p>
                              <div {...justifyEnd}>
                                <SubmitButton
                                  color="success"
                                  id="revoke_user"
                                  onClick={onRevokeUser}
                                >
                                  Confirm
                                </SubmitButton>
                              </div>
                            </PopoverBody>
                          </Popover>
                        </>
                      ) : (
                        <>
                          {!!value.already_invited && (
                            <SubmitButton
                              size="sm"
                              className="my-3"
                              outline
                              onClick={onResendInvite}
                            >
                              Resend Invite
                            </SubmitButton>
                          )}
                        </>
                      )}
                    </div>
                  </FormGroup>
                </fieldset>
                <fieldset {...fieldSet}>
                  <legend {...legendSet}><Trans>Tracking</Trans></legend>
                  {trackingOptions.map((x, index) => (
                    <FormGroup className="mb-4" key={index}
                      label={x.Name}
                      model={`.tracking.${x.Name}`}
                      addControlClass={false}
                    >
                      <Control.text style={{ backgroundColor: '#F4F7FE' }}
                        model={`.tracking.${x.Name}`}
                        component={Select}
                        options={x.Options.map((y) => ({ value: y.Name, label: y.Name }))}
                        simpleValue
                        placeholder={t('Select...')}
                      />
                    </FormGroup>
                  ))}
                </fieldset>
                <div {...justifyEnd}>
                  <SubmitButton {...nxtButton}>Save</SubmitButton>
                  <button type="button" onClick={() => setActiveTab('1')} {...nxtButton}><Trans>Prev</Trans></button>
                  <button type="button" onClick={() => setActiveTab('3')} {...nxtButton}><Trans>Next</Trans></button>
                </div>
              </React.Fragment>
            </TabPane>

            <TabPane tabId="3">
              <React.Fragment>
                <fieldset {...fieldSet}>
                  <legend {...legendSet}><Trans>Medical Insurance Information</Trans></legend>
                  <div {...rowCheck}>
                    <FormGroup label={t("Medical insurance policy number")} model=".medical_number" className="col-sm">
                      <Control.text model=".medical_number" updateOn="blur" placeholder="Insurance Number" autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                    <FormGroup label={t("Insurance Start Date")} model=".start_date_insurance" className="col-sm">
                      {/* <Input type="date" className="form-control" model=".start_date_insurance" /> */}
                      <DatePicker className="form-control" model=".start_date_insurance" />
                    </FormGroup>
                    <FormGroup
                      label={t("Insurance End Date")}
                      model=".end_date_insurance"
                      className="col-sm">
                      {/* <Input type="date" className="form-control" model=".end_date_insurance" /> */}
                      <DatePicker className="form-control" model=".end_date_insurance" />
                    </FormGroup>
                  </div>
                  <div {...rowCheck}>
                    <FormGroup label={t("Insurance Company name")} model=".company_name" className="col-sm">
                      <Control.text model=".company_name" placeholder={t("Insurance Company")} updateOn="blur" autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                    <FormGroup label={t("Insurance Type / Category")} model=".category" className="col-sm" addControlClass={false}>
                      <Control.text style={{ backgroundColor: '#F4F7FE' }}
                        model=".category"
                        component={Select}
                        options={insuranceOptions}
                        simpleValue
                        clearable={false}
                        searchable={false}
                        placeholder={t("Type of Insurance")}
                      />
                    </FormGroup>
                    <FormGroup label={t("Insurance Amount")} model=".amount" className="col-sm">
                      <Control.text model=".amount" updateOn="blur" placeholder={t("Maximum Coverage Amount")} autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                  </div>
                </fieldset>
                <fieldset {...fieldSet}>
                  <legend {...legendSet}><Trans>Bank Information</Trans></legend>
                  <div {...rowCheck}>
                    <FormGroup label={t("Bank Name")} model=".bank_name" className="col-sm">
                      <Control.text model=".bank_name" updateOn="blur" placeholder={t("Full Bank Name")} autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                    <FormGroup label={t("Account Number")} model=".account_number" className="col-sm">
                      <Control.text model=".account_number" updateOn="blur" placeholder={t("Account Number")} autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                    <FormGroup label={t("IBAN")} model=".iban" className="col-sm">
                      <Control.text model=".iban" updateOn="blur" placeholder={t("International Bank Account Number")} autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                  </div>
                  <div {...rowCheck}>
                    <FormGroup label={t("Route")} model=".route" className="col-sm">
                      <Control.text model=".route" updateOn="blur" placeholder={t("Bank Route")} autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                    <FormGroup label={t("Swift")} model=".swift" className="col-sm">
                      <Control.text model=".swift" updateOn="blur" placeholder={t("SWIFT")} autoComplete="off" autoCorrect="off" spellCheck="off" />
                    </FormGroup>
                    <FormGroup
                      label={t("Country")}
                      model=".country"
                      addControlClass={false}
                      className="col-sm" >
                      <Control.text style={{ backgroundColor: '#F4F7FE' }}
                        model=".country"
                        component={Select}
                        options={countryOptions}
                        simpleValue
                        clearable={false}
                        searchable={true}
                        placeholder={t('Bank Country...')}
                      />
                    </FormGroup>
                  </div>
                </fieldset>
                <div {...justifyEnd}>
                  <SubmitButton {...nxtButton}>Save</SubmitButton>
                  <button type="button" onClick={() => setActiveTab('2')} {...nxtButton}><Trans>Prev</Trans></button>
                  <button type="button" onClick={() => setActiveTab('4')} {...nxtButton}><Trans>Next</Trans></button>
                </div>
              </React.Fragment>
            </TabPane>

            <TabPane tabId="4">
              <React.Fragment>
                <fieldset {...fieldSet}>
                  <legend {...legendSet}><Trans>Allowances</Trans></legend>
                  <FormGroup label={t("Allowances")} addControlClass={false} className="mt-2">
                    <label className="d-block alert-warning"><Trans>Monthly Salary Should be entered first</Trans></label>
                    <Table size="sm">
                      <thead>
                        <tr>
                          <th className="text-nowrap">
                            <Trans>Description</Trans>
                          </th>
                          <th className="text-nowrap">
                            <Trans>Allowance per month</Trans>
                          </th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {value.allowances.map((i, idx) => (
                          <Fieldset
                            component="tr"
                            key={idx}
                            model={track(".allowances", (v) => {
                              if (v && v.id) return v.id === i.id;
                              else if (v && v.key) return v.key === i.key;
                              return true;
                            })}
                          >
                            <td>
                              <FormGroup
                                model='.allowance_rule'
                                addControlClass={false}
                              >
                                <Control.text
                                  model='.allowance_rule' style={{ backgroundColor: '#F4F7FE', zIndex: 9999 }}
                                  component={Select}
                                  options={allowanceOptions.map((x) => ({ value: x.id, label: x.description }))}
                                  simpleValue
                                  onChange={onAllowanceRuleChange}
                                  clearable={false}
                                  searchable={false}
                                  placeholder={t('Select...')}
                                  menuPosition="fixed"
                                  menuPlacement="auto"
                                />
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup model=".amount" className="mb-0" key={`amount${idx}`}>
                                <Control.text model=".amount" validators={isCurrency} />
                              </FormGroup>
                            </td>
                            <td className="text-right">
                              <PendingButton
                                size="sm"
                                color="link"
                                onClick={(e) => { handleRemoveAllowance(e, idx); }}
                              >
                                <span className="fa fa-trash text-danger" />
                              </PendingButton>
                            </td>
                          </Fieldset>
                        ))}
                      </tbody>
                    </Table>
                  </FormGroup>
                  <div {...justifyEnd}>
                    <PendingButton
                      color="success"
                      size="sm"
                      outline
                      icon="fa fa-plus mr-1"
                      onClick={() => {
                        dispatch(
                          actions.push("local.allowances", {
                            key: shortid(),
                            description: "",
                            amount_type: "",
                            amount: "",
                            allowance_rule: "",
                            connected_organisation: ""
                          })
                        );
                      }}
                    >
                      {value.allowances.length > 0 ? t("Add Another") : t("Add New")}
                    </PendingButton>
                  </div>
                </fieldset>
                <fieldset {...fieldSet}>
                  <legend {...legendSet}><Trans>Deductions</Trans></legend>
                  <FormGroup label={t("Deductions")} addControlClass={false} className="mt-2">
                    <label className="d-block alert-warning"><Trans>Monthly Salary Should be entered first</Trans></label>
                    <Table size="sm">
                      <thead>
                        <tr>
                          <th className="text-nowrap">
                            <Trans>Description</Trans>
                          </th>
                          <th className="text-nowrap">
                            <Trans>Deductions per month</Trans>
                          </th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {value?.deductions?.map((i, idx) => (
                          <Fieldset
                            component="tr"
                            key={idx}
                            model={track(".deductions", (v) => {
                              if (v && v.id) return v.id === i.id;
                              else if (v && v.key) return v.key === i.key;
                              return true;
                            })}
                          >
                            <td>
                              <FormGroup
                                model='.deduction_rule'
                                addControlClass={false}
                              >
                                <Control.text
                                  model='.deduction_rule' style={{ backgroundColor: '#F4F7FE', zIndex: 9999 }}
                                  component={Select}
                                  options={deductionOptions.map((x) => ({ value: x.id, label: x.description }))}
                                  simpleValue
                                  onChange={onDeductionRuleChange}
                                  clearable={false}
                                  searchable={false}
                                  placeholder={t('Select...')}
                                  menuPosition="fixed"
                                  menuPlacement="auto"
                                />
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup model=".amount" className="mb-0" key={`amount${idx}`}>
                                <Control.text model=".amount" validators={isCurrency} />
                              </FormGroup>
                            </td>
                            <td className="text-right">
                              <PendingButton
                                size="sm"
                                color="link"
                                onClick={(e) => { handleRemoveDeduction(e, idx); }}
                              >
                                <span className="fa fa-trash text-danger" />
                              </PendingButton>
                            </td>
                          </Fieldset>
                        ))}
                      </tbody>
                    </Table>
                  </FormGroup>
                  <div {...justifyEnd}>
                    <PendingButton
                      color="success"
                      size="sm"
                      outline
                      icon="fa fa-plus mr-1"
                      onClick={() => {
                        dispatch(
                          actions.push("local.deductions", {
                            key: shortid(),
                            description: "",
                            amount_type: "",
                            amount: "",
                            deduction_rule: "",
                            connected_organisation: ""
                          })
                        );
                      }}
                    >
                      {value?.deductions?.length > 0 ? t("Add Another") : t("Add New")}
                    </PendingButton>
                  </div>
                </fieldset>
                <fieldset {...fieldSet}>
                  <legend {...legendSet}><Trans>End of Service Rules</Trans></legend>
                  <FormGroup model='.end_of_service' addControlClass={false} >
                    <Control.text
                      model='.end_of_service' style={{ backgroundColor: '#F4F7FE', zIndex: 9999 }}
                      component={Select}
                      options={endOfServiceOptions?.map((x) => ({ value: x.id, label: x.text }))}
                      simpleValue
                      clearable={true}
                      searchable={true}
                      placeholder={t('Select...')}
                    />
                  </FormGroup>
                  {value?.eos_details && (
                    <div className="">
                      <Table size="sm" bordered className="my-3">
                        <thead>
                          <tr>
                            <th className="text-nowrap">
                              <Trans>Total Accumulated</Trans>
                            </th>
                            <th className="text-nowrap">
                              <Trans>Monthly Accrual</Trans>
                            </th>
                            <th className="text-nowrap">
                              <Trans>Yearly Accrual</Trans>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              {value?.eos_details?.amount}
                            </td>
                            <td>
                              {value?.eos_details?.monthly_accrued}
                            </td>
                            <td>
                              {value?.eos_details?.yearly_accrued}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  )
                  }
                  <Col className="col-4 px-0">
                    <FormGroup label="Generate Monthly MJ" model=".generate_monthly_mj" className="form-g-check font-weight-bold mt-3" >
                      <Control.checkbox
                        model=".generate_monthly_mj"
                        // onChange={() => { showPayment() }}
                        className="ml-2 rtl-paid-checkbox"
                      />
                    </FormGroup>
                  </Col>
                </fieldset>
                <div {...justifyEnd}>
                  <SubmitButton {...nxtButton}>Save</SubmitButton>
                  <button type="button" onClick={() => setActiveTab('3')} {...nxtButton}><Trans>Prev</Trans></button>
                </div>
              </React.Fragment>
            </TabPane>
          </TabContent>
        </div>
      </Form>
      <HistoryModal title={t("Salary History")}>
        <div className="container">
          <Row>
            <Col>
              <Table size="sm" bordered className="my-3">
                <thead>
                  <tr>
                    <th className="text-nowrap">
                      <Trans>Salary</Trans>
                    </th>
                    <th className="text-nowrap">
                      <Trans>Changed At</Trans>
                    </th>
                    <th className="text-nowrap">
                      <Trans>Action</Trans>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {salaries.map((salary) => (
                    <tr key={salary.id}>
                      <td>
                        {salary?.salary}
                      </td>
                      <td>
                        {salary?.date}
                      </td>
                      <td>
                        <Link to={`/payroll-new/contracts/${salary.contract_id}`}>
                          <Trans>View</Trans>({salary.contract_id})
                        </Link>
                      </td>
                    </tr>
                  ))
                  }
                </tbody>
              </Table>
            </Col>
          </Row>
          <div className="row">
            <div className="col text-right">
              <Button className="mr-0" onClick={HistoryToggle}><Trans>Close</Trans></Button>
            </div>
          </div>
        </div>
      </HistoryModal>
    </Page >
  );
};

export default EmployeeEdit;
